export const DEFAULT_ACCEPTED_FILE_TYPES =
  '.js,.jsx,.mjs,.cjs,.ts,.tsx,.py,.go,.rs,.sql,.json,.yaml,.yml,.xml,.md,.markdown,.txt,.csv,.tsv,.html,.htm,.css,.scss,.less,.java,.kt,.kts,.c,.cc,.cpp,.cxx,.h,.hpp,.cs,.php,.rb,.swift,.scala,.sh,.bash,.zsh,.ps1,.bat,.cmd,.toml,.ini,.conf,.env,.log,.png,.jpg,.jpeg,.webp,.pdf,.doc,.docx,.rtf,.xls,.xlsx';
export const DEFAULT_MAX_TOTAL_FILE_SIZE = 20 * 1024 * 1024; // 20 MB
export const DEFAULT_MAX_FILE_COUNT = 5;
